import { render } from "./ResetPasswordPopup.vue?vue&type=template&id=5c66796a&scoped=true"
import script from "./ResetPasswordPopup.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPopup.vue?vue&type=script&lang=js"

import "./ResetPasswordPopup.vue?vue&type=style&index=0&id=5c66796a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c66796a"

export default script